import axios from 'axios';
const API_URL = import.meta.env.VITE_APP_API_URL;

const get = async (url, token) => {
    if (!token) {
        console.error('No token provided for API GET request'); // Log the error
        globalThis.location.href = '/login';
        throw new Error('No token provided');
    }
    try {
        const response = (await axios.get(API_URL + url, {
            headers: { Authorization: `Bearer ${token}` }
        }));
        return response;    
    } catch (error) {
        if (error.response?.status === 401) {
            console.error('Unauthorized access - redirecting to login'); // Log unauthorized access
            globalThis.location.href = '/login'; // Redirect to login page
        }
        console.error('API GET Error:', error); // Log the error
        throw error;
    }
};

const post = async (url, obj, token) => {
    if (!token) {
        console.error('No token provided for API POST request'); // Log the error
        globalThis.location.href = '/login'; // Redirect to login page
        throw new Error('No token provided');
    }
    try {
        const response = (await axios.post(API_URL + url, obj, {
            headers: { Authorization: `Bearer ${token}` }
        }));
        return response;    
    } catch (error) {
        if (error.response?.status === 401) {
            console.error('Unauthorized access - redirecting to login'); // Log unauthorized access
            globalThis.location.href = '/login'; // Redirect to login page
        }
        console.error('API POST Error:', error); // Log the error
        throw error;
    }
};

const getFile = async (url, obj, token) => {
    if (!token) {
        console.error('No token provided for API GET request'); // Log the error
        globalThis.location.href = '/login'; // Redirect to login page
        throw new Error('No token provided');
    }
    try {
        const response = (await axios.post(API_URL + url, obj, {
            headers: { Authorization: `Bearer ${token}` },
            responseType: 'blob' // Important for file download
        }));
        return response;    
    } catch (error) {
        if (error.response?.status === 401) {
            console.error('Unauthorized access - redirecting to login'); // Log unauthorized access
            globalThis.location.href = '/login'; // Redirect to login page
        }
        console.error('API GET File Error:', error); // Log the error
        throw error;
    }
};

const put = async (url, obj, token) => {
    if (!token) {
        console.error('No token provided for API PUT request'); // Log the error
        globalThis.location.href = '/login'; // Redirect to login page
        throw new Error('No token provided');
    }
    try {
        const response = (await axios.put(API_URL + url, obj, {
            headers: { Authorization: `Bearer ${token}` }
        }));
        return response;    
    } catch (error) {
        if (error.response?.status === 401) {
            console.error('Unauthorized access - redirecting to login'); // Log unauthorized access
            globalThis.location.href = '/login'; // Redirect to login page
        }
        console.error('API PUT Error:', error); // Log the error
        throw error;
    }
};

const borrar = async (url, token) => {
    if (!token) {
        console.error('No token provided for API DELETE request'); // Log the error
        globalThis.location.href = '/login'; // Redirect to login page
        throw new Error('No token provided');
    }
    try {
        const response = (await axios.delete(API_URL + url, {
            headers: { Authorization: `Bearer ${token}` }
        }));
        return response;    
    } catch (error) {
        if (error.response?.status === 401) {
            console.error('Unauthorized access - redirecting to login'); // Log unauthorized access
            globalThis.location.href = '/login'; // Redirect to login page
        }
        console.error('API DELETE Error:', error); // Log the error
        throw error;
    }
};

const uploaddoc = async (url, formData, token) => {
    return (await axios.post(API_URL + url, formData, {
        headers: { 
            Authorization: `Bearer ${token}`,
        }
    }));
};

export default {
    get,
    post,
    uploaddoc,
    getFile,
    put,
    borrar,
};
